// extracted by mini-css-extract-plugin
module.exports = {"dataItem":"DataItem_dataItem__Lv-Lf","title":"DataItem_title__3Bu1s","value":"DataItem_value__2W-OM"};